module.exports = __webpack_public_path__ + "img/sla.581c1882.png";